module.exports = __webpack_public_path__ + "img/makeup.3bc5aff0.svg";